import React from "react";
import { cn } from "../../lib/utils";

export function LoadingSpinner({ message = "در حال بارگذاری...", className }) {
  return (
    <div
      className={cn(
        "flex min-h-screen items-center justify-center bg-slate-50",
        className,
      )}
    >
      <div className="text-center text-gray-500">
        <div className="mb-3 text-[40px]">⏳</div>
        <div>{message}</div>
      </div>
    </div>
  );
}

export default LoadingSpinner;
